export class ReceivableMonitor {
  id: number;
  fund: string;
  date: Date;
  amountTED: number;
  toBankAccount: string;
  bankCode: string;
  bankName: string;
  agencyCode: number;
  agencyCheckDigit: string;
  checkingAccount: number;
  accountCheckDigit: string;
  status: string;
  statusDetail: StatusReceivableMonitor[];
  occurrencesForReturn: string;
}

export class StatusReceivableMonitor {
  date: Date;
  status: string;
}

export class ReceivableMonitorFilter {
  startDate: Date;
  endDate: Date;
  codeStatus: string;
  fileName: string;
  fundDocument: string;
  bankCode: string;
  page: number;
  pageSize: number;

  constructor(receivableMonitorFilter?) {
    receivableMonitorFilter = receivableMonitorFilter || {};
    this.startDate = receivableMonitorFilter.startDate || new Date();
    this.endDate = receivableMonitorFilter.endDate || new Date();
    this.codeStatus = receivableMonitorFilter.codeStatus || "";
    this.fileName = receivableMonitorFilter.fileName || "";
    this.fundDocument = receivableMonitorFilter.fundDocument || "";
    this.bankCode = receivableMonitorFilter.bankCode || "";
  }
}
